import { BetBuilderProvider } from '@cds/betting-offer/add-ons';
import { BetBuilderInfo, EventModel } from '@frontend/sports/betting-offer/feature/model';

import { BetslipGroupInformation } from '../../betslip/core/groups/betslip-group-information';
import { BetBuilderEventModel } from './model/bet-builder-event-model';
import { BetBuilderConfigService } from './services/bet-builder-config.service';

export function isBetbuilderEvent(event: EventModel, betBuilderConfigService: BetBuilderConfigService): boolean {
    const hasRequiredMappings = !!event.getBetBuilderConsumerFixtureId() && !!event.sportcastId;
    const isSportcastBetBuilder =
        betBuilderConfigService.isBetBuilderEnabled(event.sport.id) &&
        hasRequiredMappings &&
        !event.live &&
        event.betBuilderInfo?.betBuilderProvider === BetBuilderProvider.Default;

    const isSgpBetBuilder = !!event.betBuilderInfo?.betBuilderId && event.betBuilderInfo?.betBuilderProvider !== BetBuilderProvider.Default;

    return isSportcastBetBuilder || isSgpBetBuilder;
}

export function getBetbuilderTypeValue<T extends { Sgp: T['Sgp']; BetBuilder: T['BetBuilder'] }>(
    event: EventModel,
    enumValue: T,
): T['BetBuilder' | 'Sgp'] {
    return event.betBuilderInfo?.betBuilderId && event.betBuilderInfo?.betBuilderProvider !== BetBuilderProvider.Default
        ? enumValue.Sgp
        : enumValue.BetBuilder;
}

export function getBetslipGroupInformation(event: EventModel | BetBuilderEventModel): BetslipGroupInformation | undefined {
    return event.betBuilderInfo?.betBuilderId && event.betBuilderInfo?.betBuilderProvider !== BetBuilderProvider.Default
        ? { groupId: event.betBuilderInfo.betBuilderId, provider: event.betBuilderInfo.betBuilderProvider }
        : undefined;
}

// blacklisting non-enabled providers, because in the future we may have other in-house providers
const providerWithoutBadge = new Set<BetBuilderProvider | undefined>([BetBuilderProvider.None, BetBuilderProvider.Default]);
export function isProviderSupportingBadges(betBuilderInfo: BetBuilderInfo | null): boolean {
    return !!betBuilderInfo?.betBuilderId && !providerWithoutBadge.has(betBuilderInfo?.betBuilderProvider);
}
